import { LDProvider } from "launchdarkly-react-client-sdk";
import { PrimeReactProvider } from "primereact/api";

import { createRoot } from "react-dom/client";
import {
  DDErrorBoundary,
  initDatadog,
  initDatadogLogs,
  getDatadogVersion,
} from "sj-ui-toolkit/src/integrations";
import { ThemeProvider } from "sj-ui-toolkit/src/theme/ThemeProvider.js";
import { ToastProvider } from "sj-ui-toolkit/src/hooks/ToastContext.js";

// Import atlas base styles
import "sj-ui-toolkit/src/atlas/styles/index.scss";

// Import tailwind via styles.css
import "./styles.css";

// Import theme utilities
import "sj-ui-toolkit/src/atlas/utils/themeUtilities.css";

// App component
import App from "./App";
import { PwaUpdatePrompt } from "./components/Pwa/PwaUpdatePrompt";

const version = getDatadogVersion();

// Log app info on startup
console.log(`🚀 learn${version ? `: v${version}` : " (no version)"}`);

// Datadog RUM credentials below are unique to learn-frontend.
// If the RUM app changes, update applicationId and clientToken accordingly.

// Initialize RUM
initDatadog({
  applicationId: "4c49607d-9011-428d-85c4-dbbd5a857cdf", // ⚠️ UNIQUE to learn
  clientToken: "pub2a87c22f101916bc384bb68f78897aa0", // ⚠️ UNIQUE to learn
  service: "learn-frontend",
  version, // Dev: Git SHA, Prod: Semantic version
});

// Initialize Browser Logs (uses same client token as RUM)
initDatadogLogs({
  clientToken: "pub2a87c22f101916bc384bb68f78897aa0", // ⚠️ UNIQUE to learn
  service: "learn-frontend",
  version,
  forwardErrorsToLogs: true,
  forwardConsoleLogs: ["error"],
});

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}

createRoot(container).render(
  // <React.StrictMode>
  <PrimeReactProvider>
    <ThemeProvider loaderOptions={{ loaderOn: true, hideLoaderText: false }}>
      <LDProvider
        clientSideID={import.meta.env.VITE_APP_LAUNCHDARKLY_ID || "638e4dc08684e4120d9a92ef"}
      >
        <ToastProvider>
          <DDErrorBoundary>
            <PwaUpdatePrompt />
            <App />
          </DDErrorBoundary>
        </ToastProvider>
      </LDProvider>
    </ThemeProvider>
  </PrimeReactProvider>
  // </React.StrictMode>
);
